import ClientImg from "assets/air/client.png";
import AirLogo from "assets/logo/logo_air_white.png";
import AirMorning from "assets/logo/logo_morning_white.png";

const Client = ({ type }: { type: string }) => {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">
                주요 Client 현황
            </p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%] responsive1200:py-[10%]">
                <div
                    className="animate-fade-in relative bg-cover bg-top flex flex-col gap-5 items-center justify-center bg-no-repeat h-[300px] px-[4%]"
                    style={{ backgroundImage: `url(${ClientImg})` }}
                >
                    <img src={type === "air" ? AirLogo : AirMorning} alt="logo" className="max-w-[70%]" />
                    <p className="text-white text-center leading-6 text-[15px] break-keep responsive650:text-[14px]">
                        고객의 성공이 곧 우리의 성공이라는 생각으로 <br /> 늘 고객과 함께 할 수 있는 일류 물류 회사가 되겠습니다{" "}
                    </p>
                </div>

                <div className="grid mt-12 mb-4 grid-cols-2">
                    <div className="flex responsive1200:gap-[16px]">
                        <div className="flex-col items-center gap-4 hidden responsive1200:flex">
                            <div className="w-[5px] h-[5px] bg-air rounded-full" />
                            <div className="h-full w-[1px] bg-[#999] opacity-40" />
                        </div>
                        <div className="w-full grid grid-cols-2 responsive1200:grid-cols-1">
                            <div className="flex gap-9">
                                <div className="flex flex-col items-center gap-4 responsive1200:hidden">
                                    <div className="w-[5px] h-[5px] bg-air rounded-full" />
                                    <div className="h-full w-[1px] bg-[#999] opacity-40" />
                                </div>
                                <ul className="text-[#1c2844] text-[15px] leading-7 pt-3 responsive1200:text-[14px] responsive1200:leading-[1.5]">
                                    <li>코오롱패션 머티리얼</li>
                                    <li>LG패션</li>
                                    <li>(주)세창상사</li>
                                    <li>(주)효창</li>
                                    <li>(주)신원</li>
                                    <li>(주)효성</li>
                                    <li>(주)영텍스타일</li>
                                    <li>(주)신한산업</li>
                                    <li>제일모직</li>
                                    <li>대한방직</li>
                                    <li>(주)노브랜드</li>
                                    <li>(주)태광산업</li>
                                </ul>
                            </div>
                            <div className="flex gap-9">
                                <div className="flex flex-col items-center gap-4 responsive1200:hidden">
                                    <div className="w-[5px] h-[5px] bg-air rounded-full" />
                                    <div className="h-full w-[1px] bg-[#999] opacity-40" />
                                </div>
                                <ul className="text-[#1c2844] text-[15px] leading-7 pt-3 responsive1200:pt-0 responsive1200:text-[14px] responsive1200:leading-[1.5]">
                                    <li>(주)성안</li>
                                    <li>(주)풍인무역</li>
                                    <li>한솔섬유(주)</li>
                                    <li>최신물산(주)</li>
                                    <li>(주)세아상역</li>
                                    <li>패션그룹형지</li>
                                    <li>신흥(주)</li>
                                    <li>(주)케이에스케이</li>
                                    <li>KATRI</li>
                                    <li>FITI</li>
                                    <li>TK 케미칼(주)</li>
                                    <li>(구 동국무역)</li>
                                    <li>(주)아람인터택스</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="flex responsive1200:gap-[16px]">
                        <div className="flex-col items-center gap-4 hidden responsive1200:flex">
                            <div className="w-[5px] h-[5px] bg-air rounded-full" />
                            <div className="h-full w-[1px] bg-[#999] opacity-40" />
                        </div>

                        <div className="w-full grid grid-cols-2 responsive1200:grid-cols-1 responsive1200:self-start">
                            <div className="flex gap-9">
                                <div className="flex flex-col items-center gap-4 responsive1200:hidden">
                                    <div className="w-[5px] h-[5px] bg-air rounded-full" />
                                    <div className="h-full w-[1px] bg-[#999] opacity-40" />
                                </div>
                                <ul className="text-[#1c2844] text-[15px] leading-7 pt-3 responsive1200:text-[14px] responsive1200:leading-[1.5]">
                                    <li>(주)유베이스인터내셔널</li>
                                    <li>(주)덕산엔터프라이즈</li>
                                    <li>(주)팬코</li>
                                    <li>(주)영도벨벳</li>
                                    <li>(주)삼일니트</li>
                                    <li>(주)영텍스타일</li>
                                    <li>(주)을화</li>
                                    <li>덕성피엔티(주)</li>
                                    <li>삼일방직(주)</li>
                                    <li>한세실업(주)</li>
                                    <li>(주)대농</li>
                                    <li>벤텍스(주)</li>
                                </ul>
                            </div>
                            <div className="flex gap-9">
                                <div className="flex flex-col items-center gap-4 responsive1200:hidden">
                                    <div className="w-[5px] h-[5px] bg-air rounded-full" />
                                    <div className="h-full w-[1px] bg-[#999] opacity-40" />
                                </div>
                                <ul className="text-[#1c2844] text-[15px] leading-7 pt-3 responsive1200:pt-0 responsive1200:text-[14px] responsive1200:leading-[1.5]">
                                    <li>sft inc</li>
                                    <li>테평양물산(주)</li>
                                    <li>신성통장(주)</li>
                                    <li>(주)영원무역</li>
                                    <li>(주)윌비스</li>
                                    <li>(주)코라인터내셔날</li>
                                    <li>(주)부천</li>
                                    <li>(주)극동</li>
                                    <li>(주)새론인터내쇼날</li>
                                    <li>(주)성광</li>
                                    <li>(주)영우티앤에프</li>
                                    <li>이외 9,000개 사</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Client;
